import { React, useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import AOS from 'aos';
import 'aos/dist/aos.css';
import './App.css'
import HomePage from './components/frontend/pages/home/HomePage';
import { SidebarProvider } from './components/contexts/SidebarContext';
import Questions from './components/frontend/pages/questions/Questions';

import Login from './components/backend/pages/auth/Login.jsx';
import AdminDashboard from './components/backend/pages/dashboard/AdminDashboard.jsx';
import CreateCategory from './components/backend/pages/categories/CreateCategory.jsx';
import ShowCategory from './components/backend/pages/categories/ShowCategories.jsx';
import EditCategory from './components/backend/pages/categories/EditCategory.jsx';
import UploadQuestion from './components/backend/pages/questions/UploadQuestion.jsx';
import ViewQuestions from './components/backend/pages/questions/ViewQuestions.jsx';
import UpdateQuestion from './components/backend/pages/questions/UpdateQuestion.jsx';
import QuestionType from './components/frontend/pages/questions/QuestionType.jsx';
import ConfirmPayment from './components/frontend/pages/payments/ConfirmPayment.jsx';
import FailedPayment from './components/frontend/pages/payments/FailedPayment.jsx';
import PendingPayment from './components/frontend/pages/payments/PendingPayment.jsx';
import PaymentSuccess from './components/frontend/pages/payments/ThankYou.jsx';
import AboutUs from './components/frontend/pages/about/AboutUs.jsx';
import Contact from './components/frontend/pages/contact/Contact.jsx';
import { useServiceWorker } from './hooks/useServiceWorker.js';
import PrivacyPolicy from './components/frontend/pages/policy/PrivacyPolicy.jsx';
import TermsOfService from './components/frontend/pages/policy/TermsOfService.jsx';
import VerifiedTutors from './components/frontend/pages/tutors/VerifiedTutors.jsx';
import ApplyAsATutor from './components/frontend/pages/tutors/ApplyAsATutor.jsx';
import TutorPayment from './components/frontend/pages/tutors/TutorPayment.jsx';
import PaymentPageSuccess from './components/frontend/pages/tutors/PaymentPageSuccess.jsx';
import TutorThankYou from './components/frontend/pages/tutors/ThankYou.jsx';
import TutorAuthLogin from './components/frontend/pages/auth/TutorAuthLogin.jsx';
import TutorDashboard from './components/frontend/pages/dashboard/TutorDashboard.jsx';
import FailedTutorPayment from './components/frontend/pages/tutors/FailedTutorPayment.jsx';
import PendingTutorPayment from './components/frontend/pages/tutors/PendingTutorPayment.jsx';
import ViewTutors from './components/backend/pages/users/ViewTutors.jsx';
import UpdateTutors from './components/backend/pages/users/UpdateTutors.jsx';
import PackageSuccess from './components/frontend/pages/questions/Packages.jsx';
import FullPackage from './components/frontend/pages/questions/Packages.jsx';
import ApprovePaymentConfirmation from './components/frontend/pages/questions/ApprovePaymentConfirmation.jsx';
import PackageDemands from './components/backend/pages/packages/PackageDemands.jsx';



function App() {

   useEffect(() => {
     // Initialize AOS animations
     AOS.init({ duration: 1000 });
 
   }, []);
  useServiceWorker();
  return (
    <>
      <SidebarProvider>
        <Router>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/verified-tutors" element={<VerifiedTutors />} />
            <Route path="/tutors/apply" element={<ApplyAsATutor />} />
            <Route path="/payment" element={<TutorPayment />} />
            <Route path="/packages" element={<FullPackage />} />
            <Route path="/approve/payment/confirm" element={<ApprovePaymentConfirmation />} />
            {/* <Route path="/payment/package" element={<PackagePayment />} />
            <Route path="/packages/success" element={<PackageSuccess />} /> */}

            {/* dashbaord */}
            <Route path="/tutor/login" element={<TutorAuthLogin />} />
            <Route path="/tutor/dashboard" element={<TutorDashboard />} />
            <Route path="/admin/tutors/edit/:id" element={<UpdateTutors />} />
            <Route path="/admin/packages" element={<PackageDemands />} />

            <Route path="/questions" element={<Questions />} />
            <Route path="/questions/:examType" element={<QuestionType />} />

            <Route path="/success/thank-you" element={<TutorThankYou />} />
            <Route path="/tutor/payment-failed" element={<FailedTutorPayment />} />
            <Route path="/tutor/payment-pending" element={<PendingTutorPayment />} />
          

            <Route path="/success/:examType/thank-you" element={<PaymentSuccess />} />
            <Route path="/approve/payment" element={<ConfirmPayment />} />
            <Route path="/pending/payment" element={<PendingPayment />} />
            <Route path="/failed/payment" element={<FailedPayment />} />

            <Route path="/institutions" element={<QuestionType />} />

            <Route path="/auth/login" element={<Login />} />
            <Route path="/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/add-category" element={<CreateCategory />} />
            <Route path="/manage/category/:catId/edit/" element={<EditCategory />} />
            <Route path="/admin/categories" element={<ShowCategory />} />
             <Route path="/admin/tutors" element={<ViewTutors />} />

            <Route path="/admin/upload" element={<UploadQuestion />} />
            <Route path="/admin/questions" element={<ViewQuestions />} />
            <Route path="/admin/questions/:id/edit" element={<UpdateQuestion />} />

            
            {/* <Route path="*" element={<PageNotFound />} /> */}
          </Routes>
        </Router>
        <ToastContainer position="top-right" autoClose={3000} />
      </SidebarProvider>
    </>
  )
}

export default App
